import {useEffect, useRef} from "react";
import * as Sentry from "@sentry/react";
import {Artifact, DirectSearchResult} from "../../../../types";
import {SearchResultsRenderer} from "./SearchResultsRenderer";

/**
 * Wraps SearchResultsRenderer for the message-attached (tool-suggestion) path and emits
 * click-through metrics. Kept separate from SearchResultsRenderer because that component is
 * also used in non-tool-suggestion contexts (PostSearchPanel) that must not be counted.
 */
export function TrackedSearchResults({
    artifact,
    messageContent,
}: {
    artifact: Artifact;
    messageContent?: string;
}) {
    const results =
        (artifact.payload?.results as DirectSearchResult[]) ?? [];
    const trackedImpression = useRef(false);

    useEffect(() => {
        if (trackedImpression.current || results.length === 0) return;
        trackedImpression.current = true;
        Sentry.metrics.count("chat.tool_suggestion_shown", 1, {
            attributes: {resultCount: results.length},
        });
    }, [results.length]);

    return (
        <SearchResultsRenderer
            artifact={artifact}
            messageContent={messageContent}
            onResultClick={(result, index) => {
                Sentry.metrics.count("chat.tool_suggestion_clicked", 1, {
                    attributes: {
                        topicType: result.metadata?.topicType ?? "unknown",
                        position: index,
                    },
                });
            }}
        />
    );
}
